/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AiRecorder from './AiRecorder/index'
import Apps from './Apps/index'
import Comms from './Comms/index'
import DentalMonitoring from './DentalMonitoring/index'
import DocumentsTab from './DocumentsTab/index'
import ImagesTab from './ImagesTab/index'
import LedgerTab from './LedgerTab/index'
import MedicalTab from './MedicalTab/index'
import NotesTab from './NotesTab/index'
import ProfileTab from './ProfileTab/index'
import React from 'react'
import RefreshButton from './RefreshButton/index'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import ToggleBetaLedger from './ToggleBetaLedger/index'
import TreatmentTab from './TreatmentTab/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Tabs.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-brpv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-brpv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-3-brpv': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileTab
  viewPath={`${viewPath}/ProfileTab`}
/>
<MedicalTab
  viewPath={`${viewPath}/MedicalTab`}
/>
<TreatmentTab
  viewPath={`${viewPath}/TreatmentTab`}
/>
<LedgerTab
  viewPath={`${viewPath}/LedgerTab`}
/>
<ImagesTab
  viewPath={`${viewPath}/ImagesTab`}
/>
<DocumentsTab
  viewPath={`${viewPath}/DocumentsTab`}
/>
<NotesTab
  viewPath={`${viewPath}/NotesTab`}
/>
<Comms
  viewPath={`${viewPath}/Comms`}
/>
<Apps
  viewPath={`${viewPath}/Apps`}
/>
<DentalMonitoring
  viewPath={`${viewPath}/DentalMonitoring`}
/>
<div
  data-testid="Tabs.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-brpv': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-4-brpv': isMedia.mobile ? "0px" : "auto"}}
 className={`views-block ${styles.Horizontal1}`}
>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<ToggleBetaLedger
{...childProps}
  viewPath={`${viewPath}/ToggleBetaLedger`}
/>
)}
</SupportOnly>
<AiRecorder
  viewPath={`${viewPath}/AiRecorder`}
/>
<RefreshButton
  viewPath={`${viewPath}/RefreshButton`}
/>
</div>
</div>
{children}
</React.Fragment>)
}